import type { IconName } from "@telia/teddy";

/**
 * Maps legacy Styleguide IconDefinition names to Teddy IconName values.
 *
 * Icons that are identical in both systems (e.g. "lock-open", "info", "esim",
 * "smartphone", "service-supervision", "infinite", "bar-chart") need no mapping
 * and fall through via the passthrough fallback.
 *
 * Mapping (Styleguide → Teddy):
 *   sim-card                  → simcard
 *   product-skjermforsikring  → broken-phone
 *   product-svitsj            → trade-phone
 *   mobile                    → smartphone
 *   security                  → secured-1
 *   insurance                 → broken-phone
 *   data-sim                  → simcard
 *   spotify                   → music
 */
const iconNameMap: Record<string, IconName> = {
    "sim-card": "simcard",
    "product-skjermforsikring": "broken-phone",
    "product-svitsj": "trade-phone",
    mobile: "smartphone",
    security: "secured-1",
    insurance: "broken-phone",
    "data-sim": "simcard",
    spotify: "music",
};

export const mapIconName = (name?: string): IconName | undefined => {
    if (!name) return undefined;
    return iconNameMap[name] ?? (name as IconName);
};
